import React from 'react'

const HotProduct = () => {
  return (
    <div>
      hot
    </div>
  )
}

export default HotProduct
